import React from 'react';
import DefaultSimManuelRecipient from '../components/ManulRecipient/DefaultSimManuelRecipient';
import { cpf_cnpj } from '../utils/DictionaryManagementUtils';

//= ========================================================================

const Sim_F07a_RequestPaymentToCpfManually = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <DefaultSimManuelRecipient
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
    manualName={cpf_cnpj}
  />
);

export default Sim_F07a_RequestPaymentToCpfManually;
